import {ticketStatus} from "../globals";

const RESET_DISABLED_STATUSES = new Set([
  ticketStatus.PAID,
  ticketStatus.DOWNPAID,
  ticketStatus.GRACE,
  ticketStatus.WAIT,
  ticketStatus.PARKING_GRACE,
]);

export const canResetTicket = (status) => !RESET_DISABLED_STATUSES.has(status);
